import * as CommentTrashActionTypes from '../../../constants/comments/CommentTrashActionTypes';

const initialState = {
    searchKeyword: '',
    searchType: 'writer',
};

export default (state = initialState, action) => {
    switch (action.type) {
        case CommentTrashActionTypes.CLEAR_ITEMS:
            return {
                searchKeyword: '',
                searchType: 'writer',
            };
        case CommentTrashActionTypes.SEARCH_KEYWORD:
            return Object.assign({}, state, {
                searchKeyword: action.searchKeyword,
                searchType: action.searchType,
            });
        default :
            return state;
    }
}
